import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './TabListItem.scss';
import useDroppable from 'components/helpers/hooks/useDroppable';

const TabListItem = (props) => {
    const {
        label,
        dropId,
        onDrop,
        onClick,
        selected,
        className,
        selectedItemClassName,
    } = props;

    const handleDrop = useCallback((data) => {
        onDrop && onDrop(dropId, data);
    }, [dropId, label]);

    const [droppableRef, isDragOver] = useDroppable(handleDrop);

    return (
        <div
            ref={droppableRef}
            className={classnames(
                {
                    [styles.dragOver]: isDragOver,
                    [classnames(styles.tabListItem, className)]: true,
                    [classnames(styles.selected, selectedItemClassName)]: selected,
                },
            )}
            onClick={onClick}
            role='button'
        >
            <span>{label}</span>
        </div>
    );
};


TabListItem.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    dropId: PropTypes.string,
    selected: PropTypes.bool,

    onClick: PropTypes.func.isRequired,
    onDrop: PropTypes.func,
};

TabListItem.defaultProps = {
    className: '',
    selected: false,
    label: '',
    enableDrop: false,
};

export default TabListItem;



// WEBPACK FOOTER //
// ./src/components/controls/TabContainer/TabListItem.jsx